export default __webpack_public_path__ + "static/icon-27-4-11f87cdb06522a39131c5fd5bbd12fc8.png";